const API_BASE = process.env.REACT_APP_API_URL || '/api/v1'

export async function createBooking(data) {
    const payload = {
        customer_name: data.customer_name,
        customer_phone: data.phone_number,
        address: data.address,
        brand: data.brand,
        model: data.model,
        variant: data.variant,
        color: data.colour,
        booking_amount: data.booking_amount,
        payment_type: data.payment_type,
        booking_type: data.customer_type === 'DEALER' ? 'DEALER' : 'TEST_RIDE',
    }
    const res = await fetch(`${API_BASE}/public/bookings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
    if (!res.ok) {
        const err = await res.json()
        throw new Error(err.message || 'Booking failed')
    }
    const json = await res.json()
    return json.data
}

export async function createTicket(data) {
    const res = await fetch(`${API_BASE}/public/tickets`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
    if (!res.ok) {
        const err = await res.json()
        throw new Error(err.message || 'Ticket creation failed')
    }
    const json = await res.json()
    return json.data
}
